
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  CatalogoResponse,
  AseguradoraCatalogoResponse,
} from "@/models/CatalogoResponse";
import AfiliadoService from "../services/AfiliadoService";
import Banco from "@/models/Banco";
import FormaDePago from "@/models/FormaDePago";
import RegistroPresolicitud from "@/models/RegistroPresolicitud";
import { AxiosResponse } from "axios";
import ServiceResponseSolicitud from "@/services/response-models/ServiceResponseSolicitud";
import { Action, Getter } from "vuex-class";
import User from "@/models/User";
import ValidationService from "@/services/ValidationService";
import ValidacionCedulaIt, {
  ValidacionCedulaItResp,
} from "@/models/ValidacionCedulaIt";
import ValidacionActaNacimiento, {
  ValidacionActaNacimientoResp,
} from "@/models/ValidacionActaNacimiento";
import Esigner from "@/models/Esigner";
import TipoBeneficioEnum from "@/enums/TipoBeneficioEnum";
import ServiceResponseEntity from "@/services/response-models/ServiceResponseEntity";
import VeeValidateForm from "@/vee-validate/types/VeeValidateForm";
import CustomFileInput from "@/components/CustomFileInput.vue";
import IngresoTardioService from "@/services/IngresoTardioService";
import CesantiaService from "@/services/CesantiaService";
import VejezAnticipadaService from "@/services/VejezAnticipadaService";
import {
  ParametrosValidacionRequisitosBeneficio,
  Requisito,
} from "@/models/RequisitoBeneficio";
import FirmanteContratoIngresoTardio from "@/models/FirmanteContratoIngresoTardio";
import ServiceResponseSolicitudes from "@/services/response-models/ServiceResponseSolicitudes";
import Presolicitud from "@/models/Presolicitud";
import ServiceResponseArchivos from "@/services/response-models/ServiceResponseArchivos";
import DocumentoPresolicitud from "@/models/DocumentoPresolicitud";
import ServiceResponseEntities from "@/services/response-models/ServiceResponseEntities";
import { formatFechaAfpSiembra, formatCedula } from "@/utils/HelperFunctions";
import Swal, { SweetAlertResult } from "sweetalert2";
import Inputmask from "inputmask";
import VueFormWizard from "@/vue-form-wizard/types/VueFormWizard";
import PackageResult from "@/models/PackageResult";
import VueFormWizardButton from "@/vue-form-wizard/types/VueFormWizardButton";
import ParametrosObtencionPresolicitud from "@/models/ParametrosObtencionPresolicitud";
import FormaGeneraSolicitudEnum from "@/enums/FormaGeneraSolicitudEnum";
import ValidacionCertificacionTss from "@/models/ValidacionCertificacionTss";
import FileConfig from "../FileConfig";
import TipoRequisitoEnum from "@/enums/TipoRequisitoEnum";
import TipoPensionEnum from "@/enums/TipoPensionEnum";
import ServiceResponse from "@/services/response-models/ServiceResponse";
import ConsultaFallecido, {
  ConsultaValidacionBeneficiarioResp,
} from "@/models/ConsultaFallecido";
import { extend } from "vee-validate";
import { TipoPension } from "@/models/TipoPension";
import { detectCedula } from "@/utils/DetectCedula";
import {
  convertBase64ToFile,
  convertFileToBase64,
} from "@/utils/ConvertBase64ToFile";
import { sanitizeFileName } from "@/utils/SanitizeFileName";
Vue.directive("input-mask", {
  update: function (el: any, binding: any, vnode: any) {
    const mascara: string = vnode.data.attrs.mask;
    const im = new Inputmask(mascara);
    im.mask(el);
  },
});

extend("mask", {
  validate: (value: string, params) => {
    var inputContains_ = value.indexOf("_") > -1;
    return !inputContains_;
  },
  params: [{ name: "mask" }],
  message: "El número de cuenta es inválido.",
});

class FormWizardStep {
  public tabIndex: number;
  public formWizardChildrenIndex: number;
}

@Component({ components: { CustomFileInput } })
export default class RegistroVejezAnticipada extends Vue {
  public portalUrl: string = process.env.VUE_APP_PROD_BASE_URL;
  public registroPresolicitud: RegistroPresolicitud =
    new RegistroPresolicitud();
  public afiliadoService: AfiliadoService = new AfiliadoService();
  public validationService: ValidationService = new ValidationService();
  public ingresoTardioService: IngresoTardioService =
    new IngresoTardioService();
  public cesantiaService: CesantiaService = new CesantiaService();
  public vejezAnticipadaService: VejezAnticipadaService =
    new VejezAnticipadaService();
  public fileConfig: FileConfig;
  //#region Cédula
  public cedulaFrontalServerMessage: string = "";
  public cedulaTraseraServerMessage: string = "";
  public actaNacimientoServerMessage: string = "";
  public cedulaFrontalFiles: Array<File> = [];
  public actaNacimientoFiles: Array<File> = [];
  public cedulaTraseraFiles: Array<File> = [];
  public inputCedulaFrontalIsValid: boolean = false;
  public inputCedulaTraseraIsValid: boolean = false;
  public inputActaNacimientoIsValid: boolean = false;
  //#endregion
  //#region Documento
  public documentoServerMessage: string = "";
  public documentoFiles: Array<File> = [];
  public processedBase64Images: Array<string> = [];
  //#endregion
  //#region Referencia Documento Bancario
  public referenciaDocumentoBancarioFiles: Array<File> = [];
  public cartaAseguradoraFiles: Array<File> = [];
  public showReferenciaDocumentoBancarioFilesRequiredError: boolean = false;
  public showInvalidReferenciaDocumentoBancarioFilesTypeError: boolean = false;
  public showInvalidReferenciaDocumentoBancarioFilesSizeError: boolean = false;
  public showReferenciaDocumentoBancarioServerValidationMessage: boolean =
    false;
  public showCartaAseguradoraServerValidationMessage: boolean = false;
  public referenciaDocumentoBancarioFilesRequiredMessage: string =
    "La referencia de documento bancario es requerida.";
  public cartaAseguradoraFilesRequiredMessage: string =
    "La carta de la aseguradora es requerida.";
  public referenciaDocumentoBancarioServerValidationMessage: string = "";
  public cartaAseguradoraServerValidationMessage: string = "";
  public inputReferenciaDocumentoBancarioIsValid: boolean = false;
  public inputCartaAseguradoraIsValid: boolean = false;

  //#endregion
  //#region Documentos Adicionales
  public documentoAdicionalFiles: Array<Array<File>> = [];
  public showDocumentoAdicionalFilesRequiredError: Array<boolean> = [];
  public showInvalidDocumentoAdicionalFilesTypeError: Array<boolean> = [];
  public showInvalidDocumentoAdicionalFilesSizeError: Array<boolean> = [];
  public documentoAdicionalFilesRequiredMessage: string =
    "El documento adicional es requerido";
  //#endregion
  public bottomTextThirdStep: string = "Siguiente";
  public triggerInputValidations = false;
  public formWizardButtons: Array<
    Array<VueFormWizardButton<RegistroVejezAnticipada>>
  > = [];
  public formWizardSteps: {
    firstStep: FormWizardStep;
    secondStep: FormWizardStep;
    thirdStep: FormWizardStep;

    fifthStep: FormWizardStep;
    sixthStep: FormWizardStep;
    seventhStep: FormWizardStep;
  } = {
    firstStep: {
      tabIndex: 0,
      formWizardChildrenIndex: 6,
    },
    secondStep: {
      tabIndex: 1,
      formWizardChildrenIndex: 7,
    },
    thirdStep: {
      tabIndex: 2,
      formWizardChildrenIndex: 8,
    },
    fifthStep: {
      tabIndex: 3,
      formWizardChildrenIndex: 9,
    },
    sixthStep: {
      tabIndex: 4,
      formWizardChildrenIndex: 10,
    },
    seventhStep: {
      tabIndex: 5,
      formWizardChildrenIndex: 11,
    },
  };
  public tiposDocumentoByDocumento: {
    tipoDocumentoCedula: string;
    tipoDocumentoDocumento: Array<string>;
    tipoDocumentoReferenciaDocumentoBancario: string;
    tipoDocumentoDocumentosAdicionales: Array<Array<string>>;
    tipoDocumentoActaNacimiento: string;
    tipoDocumentoCartaAseguradora: string;
  } = {
    tipoDocumentoCedula: null,
    tipoDocumentoDocumento: [],
    tipoDocumentoReferenciaDocumentoBancario: null,
    tipoDocumentoDocumentosAdicionales: [],
    tipoDocumentoActaNacimiento: null,
    tipoDocumentoCartaAseguradora: null,
  };
  public cedulaIsValid: boolean = false;
  public actaNacimientoIsValid: boolean = false;
  public documentoIsValid: boolean = false;
  public datosCedulaCoincideConBD: boolean = true;
  public datosActaNacimientoCoincideConBD: boolean = true;
  public resultValidacionCedula: ValidacionCedulaItResp = null;
  public resultValidacionActaNacimiento: ValidacionActaNacimientoResp = null;
  //#region Tipo de Documento
  public tiposDocumento: Array<Requisito> = [];
  public tiposDocumentoLoading: boolean = false;
  public tipoDocumento: Requisito = null;
  //#endregion
  //#region Select Vias Notificacion
  public viasNotificacion: Array<CatalogoResponse> = [];
  public viasNotificacionLoading: boolean = false;
  public viaNotificacion: CatalogoResponse = null;
  //#endregion
  //#region Aseguradora
  public aseguradoras: Array<AseguradoraCatalogoResponse> = [];
  public aseguradorasLoading: boolean = false;
  public aseguradora: AseguradoraCatalogoResponse = null;
  //endregion
  //#region Metodo de Pago
  public metodosDePago: Array<FormaDePago> = [];
  public metodosDePagoLoading: boolean = false;
  public metodoDePago: FormaDePago = null;
  //#endregion
  //#region Banco
  public bancos: Array<Banco> = [];
  public bancosLoading: boolean = false;
  public banco: Banco = null;
  //#endregion
  //#region Tipo de Cuenta
  public tiposDeCuenta: Array<CatalogoResponse> = [];
  public tiposDeCuentaLoading: boolean = false;
  public tipoDeCuenta: CatalogoResponse = null;
  //#endregion
  public validacionTssActualizadaDespues24hours = false;
  public numeroCuenta: string = null;
  @Getter("user") user: User;
  @Getter("validacionCertificacionTss")
  validacionCertificacionTss: ValidacionCertificacionTss;
  @Action("setUserLoggedAction") setUserLoggedAction;
  @Action("setValidacionCertificacionTssAction")
  setValidacionCertificacionTssAction;
  public loading: boolean = false;
  public numeroSolicitudCreada: number = null;
  public signUrlContrato: string = null;
  public ingresoTardioWizard: VueFormWizard = null;
  public omitirActualizacionDatos: boolean = false;
  public modificaValorViaNotificacion: boolean = false;
  public valorViaNotificacion: string = null;
  //#region Edición
  public currentPresolicitud: Presolicitud = null;
  public documentosCurrentPresolicitud: DocumentoPresolicitud[] = [];
  public documentosAdicionales: DocumentoPresolicitud[] = [];
  public numeroSolicitud: number = null;
  public isEditing: boolean = false;
  public loadingFiles: boolean = false;
  public previousCedulaFrontalFiles: Array<DocumentoPresolicitud> = [];
  public previousCedulaTraseraFiles: Array<DocumentoPresolicitud> = [];
  public previousActaNacimientoFiles: Array<DocumentoPresolicitud> = [];
  public previousDocumentoFiles: Array<DocumentoPresolicitud> = [];
  public previousReferenciaDocumentoBancarioFiles: Array<DocumentoPresolicitud> =
    [];

  public previousCartaAseguradoraFiles: Array<DocumentoPresolicitud> = [];
  public previousDocumentoAdicionalFiles: Array<DocumentoPresolicitud> = [];
  public removedFiles: Array<DocumentoPresolicitud> = [];

  public TiposPension: Array<CatalogoResponse> = [];
  public TipoPension: CatalogoResponse = null;
  //#endregion
  public nuevaCartaAseguradoraAgregada: boolean = false;
  public callInputValidation() {
    this.triggerInputValidations = !this.triggerInputValidations;
  }
  public created() {
    if (this.user.esAfiInactivo) this.$router.push("/");

    this.fileConfig = new FileConfig(5, [
      "image/jpeg",
      "image/jpg",
      "image/tiff",
      "image/png",
      "application/pdf",
    ]);
    window.addEventListener("beforeunload", this.beforeUnloadHandler);
  }

  public async mounted() {
    this.ingresoTardioWizard = this.$refs.ingresoTardioWizard as VueFormWizard;
    await this.updateUser();
    if (this.$route.query.numeroSolicitud) {
      this.numeroSolicitud = Number(this.$route.query.numeroSolicitud);
      this.isEditing = !!this.numeroSolicitud;
      if (this.isEditing) {
        this.showLoadingAlert(
          "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital de beneficios."
        );
        this.currentPresolicitud = await this.getPresolicitud();
        if (this.currentPresolicitud.solCancelada) {
          this.showLoadingConfirm("Esta solicitud ha sido cancelada.", () => {
            this.$router.push("/home");
            Swal.close();
          });
          return;
        }
        const currentDate: string = (
          await this.afiliadoService.getCurrentDate()
        ).data.currentDate;
        const hourDifference: number =
          Math.abs(
            new Date(currentDate).getTime() -
              new Date(this.currentPresolicitud.fechaSolicitud).getTime()
          ) /
          (60 * 60 * 1000);
        const hourDifferenceGreaterThan24: boolean = hourDifference >= 24;
        if (hourDifferenceGreaterThan24) {
          this.validacionTssActualizadaDespues24hours = true;
          //await this.validarTss();
        }
        this.documentosCurrentPresolicitud =
          await this.getDocumentosPresolicitud();
        //
        //Update UI values from server
        this.datosCedulaCoincideConBD =
          this.currentPresolicitud.cedulaCoincide &&
          this.currentPresolicitud.nombreCoincide &&
          this.currentPresolicitud.fechaNacimientoCoincide;
        this.resultValidacionCedula = new ValidacionCedulaItResp(
          this.currentPresolicitud.cedulaCoincide,
          this.currentPresolicitud.nombreCoincide,
          this.currentPresolicitud.fechaNacimientoCoincide
        );
        // this.resultValidacionActaNacimiento = new ValidacionActaNacimientoResp(this.currentPresolicitud.nombreActaNacimientoCoincide,
        //                                                                        this.currentPresolicitud.fechaNacimientoActaNacimientoCoincide);
        //Swal.close();
      }
    }

    this.formWizardButtons = [
      [
        {
          text: "Siguiente",
          action: this.verificarCedulaYActaNacimiento,
          className: "ml-auto siembra-orange-button big-button",
          isLoadingButton: true,
          nextAction: (props: any, _this?: RegistroVejezAnticipada) => {
            props.nextTab();
            props.isLoadingButton = true;

            if (
              this.documentosAdicionales != null &&
              this.documentosAdicionales.length > 0
              //     false
              //     //_this.datosCedulaCoincideConBD &&
              //     //!_this.existPreviousDocumentoFiles
              //     //&& _this.datosActaNacimientoCoincideConBD
            ) {
              _this.enableStep(
                _this.formWizardSteps.secondStep.formWizardChildrenIndex
              );
            } else {
              props.nextTab();
              _this.resetSecondStep();
              _this.disableStep(
                _this.formWizardSteps.secondStep.formWizardChildrenIndex
              );
            }
          },
          display: () => true,
        },
      ],
      [
        {
          text: "Anterior",
          action: () =>
            new Promise((resolve, reject) => {
              resolve(true);
            }),
          className: "mr-auto siembra-orange-button big-button",
          isLoadingButton: false,
          nextAction: (props: any) => props.prevTab(),
          display: () => true,
        },
        {
          text: "Omitir",
          action: () => {
            this.omitirActualizacionDatos = true;
            return new Promise((resolve, reject) => {
              resolve(this.secondStepIsValid());
            });
          },
          className: "ml-auto siembra-blue-button big-button",
          isLoadingButton: false,
          nextAction: (props: any) => props.nextTab(),
          display: () =>
            !this.existPreviousDocumentoFiles &&
            this.documentosAdicionales.length == 0,
        },
        {
          text: "Validar",
          action: () => {
            return new Promise((resolve, reject) => {
              if (!this.documentosAdicionalesAreValid()) {
                this.disableStep(
                  this.formWizardSteps.fifthStep.formWizardChildrenIndex
                );
                resolve(false);
                return;
              }

              if (
                (this.existPreviousDocumentoFiles &&
                  this.previousDocumentoRequiereCambioDoc &&
                  !this.documentoIsValid) ||
                (!this.existPreviousDocumentoFiles &&
                  this.documentosAdicionales.length == 0 &&
                  !this.documentoIsValid)
              ) {
                this.callInputValidation();
                resolve(false);
                return;
              }
              this.enableStep(
                this.formWizardSteps.fifthStep.formWizardChildrenIndex
              );
              resolve(this.secondStepIsValid());
              return;
            });
          },
          className: "ml-3 siembra-orange-button big-button",
          isLoadingButton: false,
          nextAction: (props: any, _this: RegistroVejezAnticipada) => {
            props.nextTab();
            _this.enableStep(
              _this.formWizardSteps.secondStep.formWizardChildrenIndex
            );
          },
          display: () => true,
        },
      ],
      [
        {
          text: "Siguiente",
          action: () => {
            return new Promise((resolve, reject) => {
              (
                this.$refs
                  .registroIngresoTardioFormTipoRetiro as VeeValidateForm
              )
                .validate()
                .then((formIsValid) => {
                  if (this.TipoPension) {
                    if (
                      this.TipoPension.value == TipoPensionEnum.RetiroProgramado
                    ) {
                      this.registroPresolicitud.presolicitud.estado = "P";
                      formIsValid = true;
                    }

                    if (
                      this.TipoPension.value == TipoPensionEnum.RentaVitalicia
                    ) {
                      this.metodoDePago = null;
                      if (formIsValid) {
                        //Si llegamos hasta aqui, el formulario es valido y el documento bancario tambien
                        //   this.completarPresolicitud().then((result) => {
                        //       resolve(result);
                        //   });
                        if (
                          this.cartaAseguradoraFiles.length > 0 ||
                          this.previousCartaAseguradoraFiles.length > 0
                        ) {
                          this.completarPresolicitud().then((result) => {
                            resolve(result);
                          });
                        }
                      } else {
                        this.onGuardarHastaRentaVitalicia();

                        return;
                      }
                    }
                  }

                  resolve(formIsValid);
                });
            });
          },
          className: "ml-auto siembra-orange-button big-button",
          isLoadingButton: true,
          nextAction: (props: any, _this: RegistroVejezAnticipada) => {
            if (
              this.TipoPension &&
              this.TipoPension.value == TipoPensionEnum.RetiroProgramado
            ) {
              props.nextTab();
            }
            if (
              this.TipoPension &&
              this.TipoPension.value == TipoPensionEnum.RentaVitalicia
            ) {
              _this.ingresoTardioWizard.changeTab(
                props.activeTabIndex,
                _this.formWizardSteps.sixthStep.tabIndex
              );
              _this.disableStep(
                _this.formWizardSteps.firstStep.formWizardChildrenIndex
              );
              _this.disableStep(
                _this.formWizardSteps.secondStep.formWizardChildrenIndex
              );
              _this.disableStep(
                _this.formWizardSteps.fifthStep.formWizardChildrenIndex
              );
              _this.disableStep(
                _this.formWizardSteps.thirdStep.formWizardChildrenIndex
              );
              if (_this.generaSolicitudAutomatica) {
                props.nextTab();
                _this.disableStep(
                  _this.formWizardSteps.sixthStep.formWizardChildrenIndex
                );
              }
            }
          },
          display: () => !this.isRentaVitalicia,
        },
        //misma funcion pero el boton se llama guardar , esto
        //es cuando es renta vitalicia
        {
          text: "Guardar",
          action: () => {
            return new Promise((resolve, reject) => {
              (
                this.$refs
                  .registroIngresoTardioFormTipoRetiro as VeeValidateForm
              )
                .validate()
                .then((formIsValid) => {
                  if (this.TipoPension) {
                    if (
                      this.TipoPension.value == TipoPensionEnum.RetiroProgramado
                    ) {
                      formIsValid = true;
                    }

                    if (
                      this.TipoPension.value == TipoPensionEnum.RentaVitalicia
                    ) {
                      this.metodoDePago = null;
                      if (formIsValid) {
                        //Si llegamos hasta aqui, el formulario es valido y el documento bancario tambien
                        //   this.completarPresolicitud().then((result) => {
                        //       resolve(result);
                        //   });
                        if (
                          this.cartaAseguradoraFiles.length > 0 ||
                          this.previousCartaAseguradoraFiles.length > 0
                        ) {
                          this.registroPresolicitud.presolicitud.estado = "P";
                          this.registroPresolicitud.presolicitud.esModificable =
                            false;
                          this.completarPresolicitud().then((result) => {
                            resolve(result);
                          });
                        } else {
                          this.onGuardarHastaRentaVitalicia();
                          return;
                        }
                      }
                    }
                  }

                  resolve(formIsValid);
                });
            });
          },
          className: "ml-auto siembra-orange-button big-button",
          isLoadingButton: true,
          nextAction: (props: any, _this: RegistroVejezAnticipada) => {
            if (
              this.TipoPension &&
              this.TipoPension.value == TipoPensionEnum.RetiroProgramado
            ) {
              props.nextTab();
            }
            if (
              this.TipoPension &&
              this.TipoPension.value == TipoPensionEnum.RentaVitalicia
            ) {
              _this.ingresoTardioWizard.changeTab(
                props.activeTabIndex,
                _this.formWizardSteps.sixthStep.tabIndex
              );
              _this.disableStep(
                _this.formWizardSteps.firstStep.formWizardChildrenIndex
              );
              _this.disableStep(
                _this.formWizardSteps.secondStep.formWizardChildrenIndex
              );
              _this.disableStep(
                _this.formWizardSteps.fifthStep.formWizardChildrenIndex
              );
              _this.disableStep(
                _this.formWizardSteps.thirdStep.formWizardChildrenIndex
              );
              if (_this.generaSolicitudAutomatica) {
                props.nextTab();
                _this.disableStep(
                  _this.formWizardSteps.sixthStep.formWizardChildrenIndex
                );
              }
            }
          },
          display: () => this.isRentaVitalicia,
        },
      ],

      [
        {
          text: "Anterior",
          action: () =>
            new Promise((resolve, reject) => {
              resolve(true);
            }),
          className: "mr-auto mt-4 siembra-blue-button big-button",
          isLoadingButton: false,
          nextAction: (props: any, _this?: RegistroVejezAnticipada) => {
            props.prevTab();
          },
          display: () => true,
        },
        {
          text: "Siguiente",
          action: () => {
            return new Promise((resolve, reject) => {
              (this.$refs.registroIngresoTardioForm as VeeValidateForm)
                .validate()
                .then((formIsValid) => {
                  //Si el form es valido, verificar si amerita validar fileInput de Documento Bancario
                  if (
                    this.fileInputRefDocumentoBancarioEsRequerido &&
                    (!this.existReferenciaDocumentoBancarioFiles ||
                      !this.inputReferenciaDocumentoBancarioIsValid)
                  ) {
                    this.callInputValidation();
                    resolve(false);
                    return;
                  }
                  if (formIsValid) {
                    //Si llegamos hasta aqui, el formulario es valido y el documento bancario tambien
                    this.completarPresolicitud().then((result) => {
                      resolve(result);
                    });
                    return;
                  }
                  resolve(formIsValid);
                });
            });
          },
          className: "ml-auto mt-4 siembra-orange-button big-button",
          isLoadingButton: true,
          nextAction: (props: any, _this: RegistroVejezAnticipada) => {
            _this.ingresoTardioWizard.changeTab(
              props.activeTabIndex,
              _this.formWizardSteps.sixthStep.tabIndex
            );
            _this.disableStep(
              _this.formWizardSteps.firstStep.formWizardChildrenIndex
            );
            _this.disableStep(
              _this.formWizardSteps.secondStep.formWizardChildrenIndex
            );
            _this.disableStep(
              _this.formWizardSteps.thirdStep.formWizardChildrenIndex
            );
            _this.disableStep(
              _this.formWizardSteps.fifthStep.formWizardChildrenIndex
            );
            if (_this.generaSolicitudAutomatica) {
              props.nextTab();
              _this.disableStep(
                _this.formWizardSteps.sixthStep.formWizardChildrenIndex
              );
            }
          },
          display: () => true,
        },
      ],
      [
        {
          text: "Ir a mis solicitudes",
          action: this.navigateToSolicitudes,
          className: "ml-auto siembra-orange-button big-button",
          isLoadingButton: false,
          display: () => true,
        },
      ],
      [
        {
          text: "Firmar",
          action: this.firmarContratoVejezAnticipada,
          className: "ml-auto siembra-orange-button big-button",
          isLoadingButton: true,
          nextAction: (props: any, _this: RegistroVejezAnticipada) => {
            window.removeEventListener(
              "beforeunload",
              this.beforeUnloadHandler
            );
            if (_this.signUrlContrato) {
              if (window.parent) {
                window.parent.location.href = _this.signUrlContrato;
              } else {
                window.location.href = _this.signUrlContrato;
              }
            }
          },
          display: () => true,
        },
      ],
    ];

    // if (this.currentPresolicitud) {
    //     if (this.currentPresolicitud.permiteFirma) {
    //         //this.ignoreFormValidation = true;
    //         this.setFieldValues();
    //         this.moveToFifthStepAndDisableTheRest();
    //         Swal.close();
    //         return;
    //     }
    // }
    await this.getTiposPension();
    await this.getTiposDocumento();
    await this.getViasNotificacion();
    await this.getAseguradoras();
    await this.getMetodosDePago();
    await this.getBancos();
    await this.getTiposDeCuenta();
    await this.getTiposDocumentoByStep();

    if (
      this.documentosCurrentPresolicitud &&
      this.documentosCurrentPresolicitud.length > 0
    ) {
      this.setPreviousFiles();
      //
      this.documentosAdicionales.forEach(
        (documentoAdicional: DocumentoPresolicitud) => {
          this.showDocumentoAdicionalFilesRequiredError.push(false);
          this.showInvalidDocumentoAdicionalFilesTypeError.push(false);
        }
      );
    }

    if (this.currentPresolicitud) {
      this.setFieldValues();

      if (this.currentPresolicitud.permiteFirma) {
        this.setFieldValues();
        this.moveToSeventhStepAndDisableTheRest();
        Swal.close();
        return;
      }

      if (
        !this.existPreviousDocumentoFiles ||
        this.previousCedulaFrontalRequiereCambioDoc ||
        this.previousCedulaTraseraRequiereCambioDoc
      ) {
        this.disableStep(
          this.formWizardSteps.secondStep.formWizardChildrenIndex
        );
      }

      let currentStep: number = this.formWizardSteps.firstStep.tabIndex;
      //Esto lo comente porque el setCurrentStepBasedOnDocumentsThatRequireToBeChanged se encarga de decidir que step se muestra
      // if (!this.currentPresolicitud.esModificable) {
      //     if (!this.datosCedulaCoincideConBD) {
      //         // // this.ingresoTardioWizard.changeTab(
      //         // //     currentStep,
      //         // //     this.formWizardSteps.secondStep.tabIndex
      //         // // );
      //         currentStep = this.formWizardSteps.secondStep.tabIndex;
      //     } else {
      //         this.ingresoTardioWizard.changeTab(
      //             currentStep,
      //             this.formWizardSteps.thirdStep.tabIndex
      //         );
      //         currentStep = this.formWizardSteps.thirdStep.tabIndex;
      //     }
      // }

      this.setCurrentStepBasedOnDocumentsThatRequireToBeChanged(currentStep);

      //Si la cedula frontal o trasera require lgun cambio doc, quitar ambas cedulas
      // if (this.previousCedulaFrontalRequiereCambioDoc
      //     || this.previousCedulaTraseraRequiereCambioDoc) {
      //         if (this.previousCedulaFrontalFiles[0])
      //             this.removeCedulaFrontalFile(this.previousCedulaFrontalFiles[0]);
      //         if (this.previousCedulaTraseraFiles[0])
      //             this.removeCedulaTraseraFile(this.previousCedulaTraseraFiles[0]);
      // }
    }
    Swal.close();
  }

  // @Watch('TipoPension')
  // onTipoPensionChanged(value:TipoPension , oldValue:TipoPension){
  //     if(value.codigo == "3"){
  //         this.bottomTextThirdStep = "Guardar"
  //     }

  // }
  get fileInputRefDocumentoBancarioEsRequerido() {
    return (
      this.siEstaCreandoYEsTransferencia ||
      this.siIsEditYEsTransferenciaYDocRequiereCambioYNoTieneComprobante
    );
  }
  get fileInputCartaAseguradoraEsRequerido() {
    return (
      this.siEstaCreandoYEsRentaVitalicia ||
      this.siIsEditYEsRentaVitaliciaYDocRequiereCambioYNoTieneCartaAseguradora
    );
  }

  get siEstaCreandoYEsTransferencia() {
    return !this.isEditing && this.metodoDePagoIsTransferenciaBancaria;
  }
  get siEstaCreandoYEsRentaVitalicia() {
    return !this.isEditing && this.isRentaVitalicia;
  }

  get siIsEditYEsTransferenciaYDocRequiereCambioYNoTieneComprobante() {
    return (
      this.isEditing &&
      this.metodoDePagoIsTransferenciaBancaria &&
      this.previousReferenciaDocumentoBancarioRequiereCambioDoc &&
      !this.existReferenciaDocumentoBancarioFiles
    );
  }
  get siIsEditYEsRentaVitaliciaYDocRequiereCambioYNoTieneCartaAseguradora() {
    return (
      this.isEditing &&
      this.isRentaVitalicia &&
      this.previousCartaAseguradoraRequiereCambioDoc &&
      !this.existCartaAseguradoraFiles
    );
  }
  public beforeUnloadHandler(e) {
    e.preventDefault();
    // If you prevent default behavior in Mozilla Firefox prompt will always be shown
    // Chrome requires returnValue to be set
    e.returnValue = "";
  }
  public removeFilesThatRequireChanges() {
    let cedulaFrontalThatRequireChange = this.previousCedulaFrontalFiles.filter(
      (x) => x.requiereCambioDoc
    )[0];
    let cedulaTraseraThatRequireChange = this.previousCedulaTraseraFiles.filter(
      (x) => x.requiereCambioDoc
    )[0];
    if (cedulaFrontalThatRequireChange || cedulaTraseraThatRequireChange) {
      this.removeCedulaFrontalFile(this.previousCedulaFrontalFiles[0]);
      this.removeCedulaTraseraFile(this.previousCedulaTraseraFiles[0]);
    }
    //
    let previousDocumentoFilesThatRequireChange =
      this.previousDocumentoFiles.filter((x) => x.requiereCambioDoc);
    previousDocumentoFilesThatRequireChange.forEach((doc) => {
      this.removeDocumentoFile(doc);
    });
    // let documentoAdicionalFilesThatRequireChange = this.documentosAdicionales
    //     .filter((x) => x.requiereCambioDoc);
    // documentoAdicionalFilesThatRequireChange
    // .forEach((doc) => {
    //     var index = this.documentosAdicionales.indexOf(doc);
    //     this.documentosAdicionales.splice(index,1);
    //     this.removedFiles.push(doc);
    // });

    //
    let previousReferenciaDocumentoBancarioFilesThatRequireChange =
      this.previousReferenciaDocumentoBancarioFiles.filter(
        (x) => x.requiereCambioDoc
      );
    previousReferenciaDocumentoBancarioFilesThatRequireChange.forEach((doc) => {
      this.removeReferenciaDocumentoBancarioFile(doc);
    });
    //
    let previousDocumentoAdicionalFilesThatRequireChange =
      this.previousDocumentoAdicionalFiles.filter((x) => x.requiereCambioDoc);
    previousDocumentoAdicionalFilesThatRequireChange.forEach((doc) => {
      this.removeDocumentoAdicionalFile(doc);
    });
    //
    // let previousActaNacimientoFilesThatRequireChange = this.previousActaNacimientoFiles
    //                                 .filter((x) => x.requiereCambioDoc);
    // previousActaNacimientoFilesThatRequireChange
    // .forEach((doc) => {
    //     this.removeActaNacimientoFile(doc);
    // });
    //
    let previousCartaAseguradoraThatRequireChange =
      this.previousCartaAseguradoraFiles.filter((x) => x.requiereCambioDoc);
    previousCartaAseguradoraThatRequireChange.forEach((doc) => {
      this.removeCartaAseguradoraFile(doc);
    });
  }

  public async updateUser(): Promise<void> {
    return new Promise((resolve, reject) => {
      const consultaFallecido = new ConsultaFallecido();
      consultaFallecido.cedulaBeneficiario = this.user.cedula;
      this.afiliadoService
        .consultarBeneficiario(consultaFallecido)
        .then(
          (
            response: AxiosResponse<
              ServiceResponseEntity<ConsultaValidacionBeneficiarioResp>
            >
          ) => {
            const consultaValidacionBeneficiarioResp = response.data.entity;
            this.user.correoElectronico1 =
              consultaValidacionBeneficiarioResp.email1;
            this.user.correoElectronico2 =
              consultaValidacionBeneficiarioResp.email2;
            this.user.celular = consultaValidacionBeneficiarioResp.celular;
            this.setUserLoggedAction(this.user);
            resolve();
          }
        )
        .catch(() => {
          reject();
        });
    });
  }

  public async validarTss(): Promise<void> {
    var result = this.validationService
      .validateCesantia("")
      .then(
        async (
          response: AxiosResponse<
            ServiceResponseEntity<ValidacionCertificacionTss>
          >
        ) => {
          if (response.data.entity.aplicaTramite) {
            this.setValidacionCertificacionTssAction(response.data.entity);
          } else {
            await this.invalidarSolicitud();
          }
        }
      )
      .catch((error) => {
        this.showErrorAlert(
          "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
          true
        );
      });
    return result;
  }

  public async validarRequisitosYTss(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const parametrosValidacionRequisitosBeneficio =
        new ParametrosValidacionRequisitosBeneficio(
          null,
          this.user.codCuenta,
          TipoRequisitoEnum.Validacion,
          TipoBeneficioEnum.Cesantia
        );
      const requisitosBeneficio = (
        await this.validationService.validarRequisitosBeneficios(
          parametrosValidacionRequisitosBeneficio
        )
      ).data.entity;
      // TODO: REMOVER
      // requisitosBeneficio.requisitos.forEach((x) => {
      //     x.cumpleRequisito = true;
      // });
      if (
        requisitosBeneficio.aplicaTramite &&
        requisitosBeneficio.requisitos.every((x) => x.cumpleRequisito)
      ) {
        this.validarTss()
          .then((result) => {
            resolve();
          })
          .catch(() => {
            resolve();
          });
      } else {
        await this.invalidarSolicitud();
        resolve();
      }
    });
  }

  @Watch("tipoDocumento")
  public onTipoDocumentoChangeInStep2(
    newValue: string,
    oldValue: string
  ): void {
    //Cuando el tipo documentoCambie si estamos en ediion hay que resetear el fileInput
    //Esto lo hacemos solo cuando esta editando, porque cuando esta creando si cambia de tipo
    //Documento no hay que resetear el fileInput
    if (this.isEditing && oldValue != null) {
      //Se evalua que all value no sea nulo para que en el first load del edit no modifique esto
      this.resetSecondStep(false);
      this.previousDocumentoFiles.splice(0, this.previousDocumentoFiles.length);
    }
  }
  @Watch("banco")
  public onBancoSelected(newValue: Banco, oldValue: Banco): void {
    if (!!oldValue) {
      const numeroCuentaInput: HTMLInputElement = this.$refs
        .numeroCuenta as HTMLInputElement;
      if (numeroCuentaInput) {
        numeroCuentaInput.value = "";
      }
      this.numeroCuenta = "";
    }
  }

  //El limpiar esta referencia se movio para el boton de registrar
  // @Watch("metodoDePago")
  // public onMetodoDePagoSelected(
  //     newValue: FormaDePago,
  //     oldValue: FormaDePago
  // ): void {
  //     // if (!!oldValue) {
  //     //     this.banco = null;
  //     //     this.tipoDeCuenta = null;
  //     //     this.numeroCuenta = null;
  //     //     this.referenciaDocumentoBancarioFiles = [];
  //     // }
  // }

  public clearUnusedFields() {
    if (!this.metodoDePagoIsTransferenciaBancaria) {
      this.banco = null;
      this.tipoDeCuenta = null;
      this.numeroCuenta = null;
      this.referenciaDocumentoBancarioFiles = [];
    }
  }

  @Watch("viaNotificacion")
  public onViaNotificacionSelected(
    newValue: CatalogoResponse,
    oldValue: CatalogoResponse
  ): void {
    if (!!oldValue) {
      this.modificaValorViaNotificacion = false;
      this.valorViaNotificacion = null;
    }
  }

  public disableStep(step: number): void {
    (
      this.ingresoTardioWizard.$children.filter(
        (x) => x.$el.localName !== "button"
      )[step].$el as HTMLElement
    ).style.pointerEvents = "none";
  }

  public enableStep(step: number): void {
    (
      this.ingresoTardioWizard.$children.filter(
        (x) => x.$el.localName !== "button"
      )[step].$el as HTMLElement
    ).style.pointerEvents = "auto";
  }

  public resetSecondStep(cleanTipoDocumentoSelect: boolean = true): void {
    if (cleanTipoDocumentoSelect) this.tipoDocumento = null;
    this.documentoFiles = [];
    // if (
    //     this.previousDocumentoFiles &&
    //     this.previousDocumentoFiles.length > 0
    // ) {
    //     this.removedFiles.push(...this.previousDocumentoFiles);
    // }
  }

  public setPreviousFiles(): void {
    this.previousCedulaFrontalFiles = [
      this.documentosCurrentPresolicitud.filter(
        (x) =>
          x.tipoDocumento === this.tiposDocumentoByDocumento.tipoDocumentoCedula
      )[0],
    ];
    this.previousCedulaTraseraFiles = [
      this.documentosCurrentPresolicitud.filter(
        (x) =>
          x.tipoDocumento === this.tiposDocumentoByDocumento.tipoDocumentoCedula
      )[1],
    ];
    this.previousDocumentoFiles = [
      ...this.documentosCurrentPresolicitud.filter(
        (x) =>
          this.tiposDocumentoByDocumento.tipoDocumentoDocumento.includes(
            x.tipoDocumento
          ) &&
          !!x.ruta &&
          !x.esAdicional
      ),
    ];
    this.previousReferenciaDocumentoBancarioFiles = [
      ...this.documentosCurrentPresolicitud.filter(
        (x) =>
          x.tipoDocumento ===
          this.tiposDocumentoByDocumento
            .tipoDocumentoReferenciaDocumentoBancario
      ),
    ];
    this.previousCartaAseguradoraFiles = [
      ...this.documentosCurrentPresolicitud.filter(
        (x) =>
          x.tipoDocumento ===
          this.tiposDocumentoByDocumento.tipoDocumentoCartaAseguradora
      ),
    ];
    this.previousDocumentoAdicionalFiles = [
      ...this.documentosCurrentPresolicitud.filter((x) => {
        return x.esAdicional;
      }),
    ];
    this.previousActaNacimientoFiles = [
      this.documentosCurrentPresolicitud.filter(
        (x) =>
          x.tipoDocumento ===
          this.tiposDocumentoByDocumento.tipoDocumentoActaNacimiento
      )[0],
    ];

    if (
      this.previousDocumentoAdicionalFiles &&
      this.previousDocumentoAdicionalFiles.length > 0
    ) {
      this.documentosAdicionales.push(
        ...this.previousDocumentoAdicionalFiles.filter(
          (x) => x.requiereCambioDoc
        )
      );
    }
  }

  public async getTiposDocumentoByStep(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      let tipoDocumentosStep1: Requisito[] = [];
      await this.vejezAnticipadaService
        .documentosRequeridos(
          String(this.formWizardSteps.firstStep.tabIndex + 1)
        )
        .then(
          (response: AxiosResponse<ServiceResponseEntities<Requisito[]>>) => {
            tipoDocumentosStep1 = response.data.entities;
          }
        );
      let tipoDocumentosStep4: Requisito[] = [];
      await this.vejezAnticipadaService
        .documentosRequeridos(
          String(this.formWizardSteps.fifthStep.tabIndex + 1)
        )
        .then(
          (response: AxiosResponse<ServiceResponseEntities<Requisito[]>>) => {
            tipoDocumentosStep4 = response.data.entities;
          }
        );

      let tipoDocumentosStep3: Requisito[] = [];
      await this.vejezAnticipadaService
        .documentosRequeridos(
          String(this.formWizardSteps.thirdStep.tabIndex + 1)
        )
        .then(
          (response: AxiosResponse<ServiceResponseEntities<Requisito[]>>) => {
            tipoDocumentosStep3 = response.data.entities;
          }
        );

      const tipoDocumentoCartaAseguradora: string =
        tipoDocumentosStep3[0].codRequisito.toString();
      const tipoDocumentoCedula: string =
        tipoDocumentosStep1[0].codRequisito.toString();
      const tipoDocumentoActaNacimiento: string =
        tipoDocumentosStep1[1]?.codRequisito.toString();
      const tipoDocumentoDocumento: Array<string> = this.tiposDocumento.map(
        (x) => x.codRequisito.toString()
      );

      const tipoDocumentoReferenciaDocumentoBancario: string =
        tipoDocumentosStep4[0]?.codRequisito.toString();
      this.tiposDocumentoByDocumento = {
        tipoDocumentoCedula,
        tipoDocumentoDocumento,
        tipoDocumentoReferenciaDocumentoBancario,
        tipoDocumentoDocumentosAdicionales: [],
        tipoDocumentoActaNacimiento,
        tipoDocumentoCartaAseguradora,
      };
      resolve();
    });
  }

  public setDatosTss(presolicitud: Presolicitud): Presolicitud {
    const presolicitudClone = {
      ...presolicitud,
    };
    //
    if (this.currentPresolicitud) {
      //Si se esta editando y se hizo una validacion de certificacionTss despues de 24 horas
      //usar los nuevos valores, de lo contrario usar los valores originales
      if (this.validacionTssActualizadaDespues24hours) {
        presolicitudClone.numeroCertTSS =
          this.validacionCertificacionTss.numeroCertificacion;
        presolicitudClone.fechaCertTSS = this.validacionCertificacionTss.fecha;
        presolicitudClone.estadoCertTSS =
          this.validacionCertificacionTss.estado;
      } else {
        presolicitudClone.numeroCertTSS =
          this.currentPresolicitud.numeroCertTSS;
        presolicitudClone.fechaCertTSS = this.currentPresolicitud.fechaCertTSS;
        presolicitudClone.estadoCertTSS =
          this.currentPresolicitud.estadoCertTSS;
      }
    } else {
      if (this.validacionCertificacionTss) {
        presolicitudClone.numeroCertTSS =
          this.validacionCertificacionTss.numeroCertificacion;
        presolicitudClone.fechaCertTSS = this.validacionCertificacionTss.fecha;
        presolicitudClone.estadoCertTSS =
          this.validacionCertificacionTss.estado;
      }
    }
    return presolicitudClone;
  }

  public setFieldValues(): void {
    if (this.previousDocumentoFiles && this.previousDocumentoFiles.length > 0) {
      this.tipoDocumento = this.tiposDocumento.find(
        (x) =>
          x.codRequisito ===
          Number(this.previousDocumentoFiles[0].tipoDocumento)
      );
    }
    this.metodoDePago = this.metodosDePago.find(
      (x) => x.formaPago === this.currentPresolicitud.formaPago
    );
    this.TipoPension = this.TiposPension.find(
      (x) => x.value === this.currentPresolicitud.tipoPension
    );
    this.aseguradora = this.aseguradoras.find(
      (x) => x.codigoAseguradora === this.currentPresolicitud.codigoAseguradora
    );
    this.banco = this.bancos.find(
      (x) => x.codigoBanco === String(this.currentPresolicitud.idBanco)
    );
    this.tipoDeCuenta = this.tiposDeCuenta.find(
      (x) => x.value === this.currentPresolicitud.tipoCuenta
    );
    this.numeroCuenta = this.currentPresolicitud.numeroCuenta;
    this.viaNotificacion = this.viasNotificacion.find(
      (x) => x.value === this.currentPresolicitud.viaNotificacion
    );
  }

  public moveToSeventhStepAndDisableTheRest(): void {
    this.ingresoTardioWizard.changeTab(
      this.formWizardSteps.firstStep.tabIndex,
      this.formWizardSteps.seventhStep.tabIndex
    );
    this.disableStep(this.formWizardSteps.firstStep.formWizardChildrenIndex);
    this.disableStep(this.formWizardSteps.secondStep.formWizardChildrenIndex);
    this.disableStep(this.formWizardSteps.thirdStep.formWizardChildrenIndex);
    this.disableStep(this.formWizardSteps.fifthStep.formWizardChildrenIndex);
    this.disableStep(this.formWizardSteps.sixthStep.formWizardChildrenIndex);
  }

  public setCurrentStepBasedOnDocumentsThatRequireToBeChanged(
    currentStep: number
  ): void {
    if (
      this.previousCedulaFrontalRequiereCambioDoc ||
      this.previousCedulaTraseraRequiereCambioDoc
    ) {
      this.ingresoTardioWizard.changeTab(
        currentStep,
        this.formWizardSteps.firstStep.tabIndex
      );
      currentStep = this.formWizardSteps.firstStep.tabIndex;
    }
    // else if (this.previousActaNacimientoRequiereCambioDoc) {
    //    this.ingresoTardioWizard.changeTab(
    //        currentStep,
    //        this.formWizardSteps.firstStep.tabIndex
    //    );
    //    currentStep = this.formWizardSteps.firstStep.tabIndex;
    //}
    else if (
      this.previousDocumentoRequiereCambioDoc ||
      this.documentosAdicionales.length > 0
    ) {
      this.ingresoTardioWizard.changeTab(
        currentStep,
        this.formWizardSteps.secondStep.tabIndex
      );
      currentStep = this.formWizardSteps.secondStep.tabIndex;
    } else if (this.previousReferenciaDocumentoBancarioRequiereCambioDoc) {
      this.ingresoTardioWizard.changeTab(
        currentStep,
        this.formWizardSteps.fifthStep.tabIndex
      );
      currentStep = this.formWizardSteps.fifthStep.tabIndex;
    }
  }

  public async getPresolicitud(): Promise<Presolicitud> {
    return new Promise((resolve, reject) => {
      this.afiliadoService
        .getPresolicitud(
          new ParametrosObtencionPresolicitud(
            this.numeroSolicitud,
            this.user.cedula,
            null,
            null
          )
        )
        .then((response: AxiosResponse<ServiceResponseSolicitudes>) => {
          if (
            response.data.solicitudes &&
            response.data.solicitudes.length > 0
          ) {
            const currentPresolicitud: Presolicitud =
              response.data.solicitudes.find(
                (x) => x.numeroSolicitud == this.numeroSolicitud
              );
            resolve(currentPresolicitud || null);
          } else {
            this.$router.push("/solicitudes-beneficiario");
            resolve(null);
          }
        })
        .catch(() => {
          reject();
        });
    });
  }

  public async getDocumentosPresolicitud(): Promise<DocumentoPresolicitud[]> {
    this.loadingFiles = true;
    return new Promise((resolve, reject) => {
      this.afiliadoService
        .getDocumentosPresolicitud(this.numeroSolicitud)
        .then((response: AxiosResponse<ServiceResponseArchivos>) => {
          this.loadingFiles = false;
          resolve(response.data.archivos);
        })
        .catch(() => {
          this.loadingFiles = false;
          reject();
        });
    });
  }

  public showLoadingAlert(message: string): void {
    Swal.fire({
      text: message,
      icon: "info",
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
    });
  }

  public showLoadingConfirm(message: string, onClose: () => void = () => {}) {
    Swal.fire({
      text: message,
      icon: "info",
      timerProgressBar: true,
      allowOutsideClick: false,
      showConfirmButton: true,
      confirmButtonText: "Ok",
      onClose,
    });
  }

  public showErrorAlert(
    message: string,
    allowOutsideClick: boolean = true
  ): void {
    Swal.fire({
      text: message,
      icon: "error",
      showConfirmButton: allowOutsideClick,
      confirmButtonText: "Ok",
      allowOutsideClick,
    });
  }

  public showInfoAlert(message: string): void {
    Swal.fire({
      text: message,
      icon: "info",
    });
  }

  get inputNumeroCuentaRules() {
    if (!this.banco) {
      return "";
    }

    if (!this.banco.validaMascara) {
      var mask = "";

      for (let i = 0; i < this.banco.lenMinimaCuenta; i++) {
        mask = mask + "9";
      }
      for (
        let i = 0;
        i < this.banco.lenMaximaCuenta - this.banco.lenMinimaCuenta;
        i++
      ) {
        mask = mask + "[9]";
      }
      this.banco.mascaraCuenta = mask;

      var mask = this.banco ? String(this.banco.mascaraCuenta) : "";
      return (
        "required|mymin-validation:" +
        String(this.banco.lenMinimaCuenta) +
        "|mymax-validation:" +
        String(this.banco.lenMaximaCuenta) +
        "|mask:" +
        String(mask)
      );
    } else {
      var mask = this.banco ? String(this.banco.mascaraCuenta) : "";
      return "required|mask:" + String(this.banco.mascaraCuenta);
    }
  }

  get currentPresolicitudEsModificable(): boolean {
    return this.currentPresolicitud && this.currentPresolicitud.esModificable;
  }

  get inputsCedulaAreValid(): boolean {
    return this.inputCedulaFrontalIsValid && this.inputCedulaTraseraIsValid;
  }
  get inputsActaNacimientoAreValid(): boolean {
    return this.inputActaNacimientoIsValid;
  }
  get inputsActaNacimiento(): boolean {
    return this.inputActaNacimientoIsValid;
  }

  get cedulaAfiliado(): string {
    return formatCedula(this.user.cedula);
  }

  get fechaNacimientoAfiliado(): string {
    return formatFechaAfpSiembra(this.user.fechaNacimientoDate);
  }

  get cedulaFiles(): File[] {
    return this.cedulaFrontalFiles.concat(this.cedulaTraseraFiles);
  }
  get getActaNacimientoFiles(): File[] {
    return this.actaNacimientoFiles;
  }
  get getCartaAseguradoraFiles(): File[] {
    return this.cartaAseguradoraFiles;
  }
  get isRentaVitalicia(): boolean {
    return (
      this.TipoPension != null &&
      this.TipoPension.value == TipoPensionEnum.RentaVitalicia
    );
  }
  get isRetiroProgramado(): boolean {
    return (
      this.TipoPension != null &&
      this.TipoPension.value == TipoPensionEnum.RetiroProgramado
    );
  }

  get previousCedulaFrontalRequiereCambioDoc(): boolean {
    return (
      this.previousCedulaFrontalFiles &&
      this.previousCedulaFrontalFiles.filter((x) => x.requiereCambioDoc)
        .length > 0
    );
  }

  get previousCedulaTraseraRequiereCambioDoc(): boolean {
    return (
      this.previousCedulaTraseraFiles &&
      this.previousCedulaTraseraFiles.filter((x) => x.requiereCambioDoc)
        .length > 0
    );
  }
  get previousActaNacimientoRequiereCambioDoc(): boolean {
    return (
      this.previousActaNacimientoFiles &&
      this.previousActaNacimientoFiles.filter((x) => x.requiereCambioDoc)
        .length > 0
    );
  }

  get previousDocumentoRequiereCambioDoc(): boolean {
    return (
      this.previousDocumentoFiles &&
      this.previousDocumentoFiles.filter((x) => x.requiereCambioDoc).length > 0
    );
  }

  get previousReferenciaDocumentoBancarioRequiereCambioDoc(): boolean {
    return (
      this.previousReferenciaDocumentoBancarioFiles &&
      this.previousReferenciaDocumentoBancarioFiles.filter(
        (x) => x.requiereCambioDoc
      ).length > 0
    );
  }

  get previousCartaAseguradoraRequiereCambioDoc(): boolean {
    return (
      this.previousCartaAseguradoraFiles &&
      this.previousCartaAseguradoraFiles.filter((x) => x.requiereCambioDoc)
        .length > 0
    );
  }

  get showCedulaFrontalInput(): boolean {
    return (
      !this.isEditing ||
      ((!this.existPreviousCedulaFrontalFiles ||
        this.previousCedulaFrontalRequiereCambioDoc ||
        this.previousCedulaTraseraRequiereCambioDoc) &&
        !this.loadingFiles)
    );
  }
  get showActaNacimientoInput(): boolean {
    return (
      !this.isEditing ||
      ((!this.existPreviousActaNacimientoFiles ||
        this.previousActaNacimientoRequiereCambioDoc) &&
        !this.loadingFiles)
    );
  }

  get showCedulaTraseraInput(): boolean {
    return (
      !this.isEditing ||
      ((!this.existPreviousCedulaTraseraFiles ||
        this.previousCedulaTraseraRequiereCambioDoc ||
        this.previousCedulaFrontalRequiereCambioDoc) &&
        !this.loadingFiles)
    );
  }

  public documentosAdicionalesAreValid(): boolean {
    return (
      !this.documentosAdicionales ||
      this.documentosAdicionales.length === 0 ||
      (this.documentosAdicionales &&
        this.documentosAdicionales.length > 0 &&
        this.documentosAdicionales.every(
          (documentoAdicional: Presolicitud, index: number) => {
            var documentoAdicionalTieneArchivo =
              !!this.documentoAdicionalFiles[index] &&
              this.documentoAdicionalFiles[index].length > 0;
            //
            if (!documentoAdicionalTieneArchivo) {
              this.showDocumentoAdicionalFilesRequiredError[index] = true;
              this.$forceUpdate();
              return false;
            }

            if (this.showInvalidDocumentoAdicionalFilesTypeError[index])
              return !this.showInvalidDocumentoAdicionalFilesTypeError[index];

            if (this.showInvalidDocumentoAdicionalFilesSizeError[index])
              return !this.showInvalidDocumentoAdicionalFilesSizeError[index];

            return true;
          }
        ))
    );
  }

  public fileRemoveConfirmAlert(
    fileName: string
  ): Promise<SweetAlertResult<boolean>> {
    return Swal.fire({
      text: "¿Deseas eliminar el archivo " + fileName + " ?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ED8B2F",
      cancelButtonColor: "#0F6CBC",
      confirmButtonText: "OK",
      reverseButtons: true,
    });
  }

  public rentaVitaliciaConfirm(): Promise<SweetAlertResult<boolean>> {
    return Swal.fire({
      html: "<div style='text-align: justify;text-justify: inter-word'>Para continuar con tu solicitud, es necesario cargar la carta de autorización de tu aseguradora. Guarda las informaciones registradas hasta el momento y cuando tengas el documento regresas y continúas con tu solicitud.</div>",
      icon: "info",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ED8B2F",
      cancelButtonColor: "#0F6CBC",
      confirmButtonText: "Guardar",
      reverseButtons: true,
    });
  }

  public onRemoveCedulaFrontalFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeCedulaFrontalFile(archivoPresolicitud);
          this.removeCedulaTraseraFile(this.previousCedulaTraseraFiles[0]);
        }
      }
    );
  }
  public onRemoveActaNacimientoFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeActaNacimientoFile(archivoPresolicitud);
          // this.removeCedulaTraseraFile(
          //     this.previousCedulaTraseraFiles[0]
          // );
        }
      }
    );
  }

  public removeCedulaFrontalFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number =
      this.previousCedulaFrontalFiles.indexOf(archivoPresolicitud);
    this.previousCedulaFrontalFiles.splice(index, 1);
    this.removedFiles.push(archivoPresolicitud);
  }
  public removeActaNacimientoFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number =
      this.previousActaNacimientoFiles.indexOf(archivoPresolicitud);
    this.previousActaNacimientoFiles.splice(index, 1);
    this.removedFiles.push(archivoPresolicitud);
  }
  public onRemoveCedulaTraseraFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeCedulaTraseraFile(archivoPresolicitud);
          this.removeCedulaFrontalFile(this.previousCedulaFrontalFiles[0]);
        }
      }
    );
  }

  public removeCedulaTraseraFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number =
      this.previousCedulaTraseraFiles.indexOf(archivoPresolicitud);
    if (index > -1) {
      this.previousCedulaTraseraFiles.splice(index, 1);
      this.removedFiles.push(archivoPresolicitud);
    }
  }

  public removeDocumentoFile(
    documentoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number = this.previousDocumentoFiles.indexOf(
      documentoPresolicitud
    );
    this.previousDocumentoFiles.splice(index, 1);
    this.removedFiles.push(documentoPresolicitud);
  }

  public removeReferenciaDocumentoBancarioFile(
    documentoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number = this.previousReferenciaDocumentoBancarioFiles.indexOf(
      documentoPresolicitud
    );
    this.previousReferenciaDocumentoBancarioFiles.splice(index, 1);
    this.removedFiles.push(documentoPresolicitud);
  }

  public removeCartaAseguradoraFile(
    documentoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number = this.previousCartaAseguradoraFiles.indexOf(
      documentoPresolicitud
    );
    this.previousCartaAseguradoraFiles.splice(index, 1);
    this.removedFiles.push(documentoPresolicitud);
  }

  public removeDocumentoAdicionalFile(
    documentoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number = this.previousDocumentoAdicionalFiles.indexOf(
      documentoPresolicitud
    );
    this.previousDocumentoAdicionalFiles.splice(index, 1);
    this.removedFiles.push(documentoPresolicitud);
  }

  public onRemoveDocumentoFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeDocumentoFile(archivoPresolicitud);
        }
      }
    );
  }

  public onRemoveReferenciaDocumentoBancarioFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeReferenciaDocumentoBancarioFile(archivoPresolicitud);
        }
      }
    );
  }
  public onRemoveCartaAseguradoraFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeCartaAseguradoraFile(archivoPresolicitud);
        }
      }
    );
  }

  public onGuardarHastaRentaVitalicia(): void {
    this.rentaVitaliciaConfirm().then((result: SweetAlertResult<boolean>) => {
      if (result.value) {
        //hacer la solicitud modificable , cuando sea consultada podra editar hazta donde realizó.
        this.registroPresolicitud.presolicitud.esModificable = true;
        //Nuevo estado R para la solicitud hasta Renta Vitalicia
        this.registroPresolicitud.presolicitud.estado = "I";
        this.completarPresolicitud().then((result) => {
          if (result) {
            Swal.fire({
              title: "Datos guardados satisfactoriamente",
              html: " Gracias por utilizar nuestra plataforma digital de beneficios. ",
              icon: "success",
              timer: 5000,
            }).then(() => {
              window.removeEventListener(
                "beforeunload",
                this.beforeUnloadHandler
              );
              this.navigateToSolicitudes();
            });
          }
        });
      }
    });
  }

  public onRemoveDocumentoAdicionalFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeDocumentoAdicionalFile(archivoPresolicitud);
          //this.documentosAdicionales.push(archivoPresolicitud);
        }
      }
    );
  }

  public getFileName(fileUrl: string): string {
    if (fileUrl.includes("/")) {
      const fileName = fileUrl.split("/");
      return fileName[fileName.length - 1];
    } else {
      return fileUrl;
    }
  }

  public async onAddOrRemoveCedulaFrontalFile(
    files: Array<File>
  ): Promise<void> {
    this.disableStep(this.formWizardSteps.secondStep.formWizardChildrenIndex);
    //this.cedulaFrontalFiles = files;
    this.cedulaIsValid = false;
    this.cedulaFrontalServerMessage = "";
    this.processedBase64Images = [];
    for (let file of files) {
      let base64Image: string;
      if (file.type === "application/pdf") {
        try {
          const base64Pdf = await convertFileToBase64(file);
          const response = await this.afiliadoService.convertPdfToImage(
            base64Pdf
          );
          if (response.data.images && response.data.images.length > 0) {
            const images = response.data.images[0];
            const files = new File(
              [Uint8Array.from(atob(images), (m) => m.codePointAt(0))],
              "myfilename.jpeg",
              { type: "image/jpeg" }
            );
            base64Image = await detectCedula(
              new File([files], "converted_pdf.png", { type: "image/png" }),
              "front"
            );
          } else {
            console.error("No se encontraron imágenes en el PDF.");
          }
        } catch (error) {
          console.error("Error al convertir PDF a imagen:", error);
        }
      } else {
        base64Image = await detectCedula(file, "front");
      }
      this.processedBase64Images.push(base64Image);
    }

    this.cedulaFrontalFiles = convertBase64ToFile(
      this.processedBase64Images,
      "cedula_frontal_solicitud"
    );
  }

  public onAddOrRemoveActaNacimientoFile(files: Array<File>): void {
    this.disableStep(this.formWizardSteps.secondStep.formWizardChildrenIndex);
    const sanitizedFiles = files.map((file) => {
      const cleanName = sanitizeFileName(file.name);
      return new File([file], cleanName, { type: file.type });
    });
    this.actaNacimientoFiles = sanitizedFiles;
    //this.actaNacimientoFiles = files;
    this.actaNacimientoIsValid = false;
    this.actaNacimientoServerMessage = "";
  }

  public cedulaFrontalValidationChanged(isValid: boolean): void {
    this.inputCedulaFrontalIsValid = isValid;
  }

  public actaNacimientoValidationChanged(isValid: boolean): void {
    this.inputActaNacimientoIsValid = isValid;
  }

  public async onAddOrRemoveCedulaTraseraFile(
    files: Array<File>
  ): Promise<void> {
    this.disableStep(this.formWizardSteps.secondStep.formWizardChildrenIndex);
    this.cedulaIsValid = false;
    this.cedulaTraseraServerMessage = "";
    this.processedBase64Images = [];
    for (let file of files) {
      let base64Image: string;
      if (file.type === "application/pdf") {
        try {
          const base64Pdf = await convertFileToBase64(file);
          const response = await this.afiliadoService.convertPdfToImage(
            base64Pdf
          );
          if (response.data.images && response.data.images.length > 0) {
            const images = response.data.images[0];
            const files = new File(
              [Uint8Array.from(atob(images), (m) => m.codePointAt(0))],
              "myfilename.jpeg",
              { type: "image/jpeg" }
            );
            base64Image = await detectCedula(
              new File([files], "converted_pdf.png", { type: "image/png" }),
              "back"
            );
          } else {
            console.error("No se encontraron imágenes en el PDF.");
          }
        } catch (error) {
          console.error("Error al convertir PDF a imagen:", error);
        }
      } else {
        base64Image = await detectCedula(file, "back");
      }
      this.processedBase64Images.push(base64Image);
    }

    this.cedulaTraseraFiles = convertBase64ToFile(
      this.processedBase64Images,
      "cedula_trasera_solicitud"
    );
  }

  public cedulaTraseraValidationChanged(isValid: boolean): void {
    this.inputCedulaTraseraIsValid = isValid;
  }

  public onAddOrRemoveDocumentoFile(files: Array<File>): void {
    const sanitizedFiles = files.map((file) => {
      const cleanName = sanitizeFileName(file.name);
      return new File([file], cleanName, { type: file.type });
    });
    //this.documentoFiles = files;
    this.documentoFiles = sanitizedFiles;
    this.documentoIsValid = false;
    this.documentoServerMessage = "";
  }

  public documentoValidationChanged(isValid: boolean): void {
    this.documentoIsValid = isValid;
  }

  public referenciaDocumentoBancarioValidationChanged(isValid: boolean): void {
    this.inputReferenciaDocumentoBancarioIsValid = isValid;
  }
  public cartaAseguradoraValidationChanged(isValid: boolean): void {
    this.inputCartaAseguradoraIsValid = isValid;
  }

  public onAddOrRemoveReferenciaDocumentoBancarioFile(
    files: Array<File>
  ): void {
    const sanitizedFiles = files.map((file) => {
      const cleanName = sanitizeFileName(file.name);
      return new File([file], cleanName, { type: file.type });
    });
    this.referenciaDocumentoBancarioFiles = sanitizedFiles;
    //this.referenciaDocumentoBancarioFiles = files;
    this.inputReferenciaDocumentoBancarioIsValid = false;
    this.referenciaDocumentoBancarioServerValidationMessage = "";
  }
  public onAddOrRemoveCartaAseguradoraFile(files: Array<File>): void {
    const sanitizedFiles = files.map((file) => {
      const cleanName = sanitizeFileName(file.name);
      return new File([file], cleanName, { type: file.type });
    });
    this.nuevaCartaAseguradoraAgregada = true;
    this.cartaAseguradoraFiles = sanitizedFiles;
    //this.cartaAseguradoraFiles = files;
    this.inputCartaAseguradoraIsValid = false;
    this.cartaAseguradoraServerValidationMessage = "";
  }

  public onAddOrRemoveDocumentoAdicionalFile(
    index: number,
    tipoDocumento: string
  ): void {
    let pond: any = this.$refs["documentoAdicional" + index][0];

    this.documentoAdicionalFiles[index] = pond.getFiles().map((x) => {
      const file = x.file;
      const sanitizedName = sanitizeFileName(file.name);
      return new File([file], sanitizedName, {
        type: file.type,
        lastModified: file.lastModified,
      });
    });

    if (
      !this.documentoAdicionalFiles[index] ||
      this.documentoAdicionalFiles[index].length === 0
    ) {
      this.tiposDocumentoByDocumento.tipoDocumentoDocumentosAdicionales[index] =
        [];
      this.showDocumentoAdicionalFilesRequiredError[index] = true;
      this.disableStep(this.formWizardSteps.fifthStep.formWizardChildrenIndex);
      this.$forceUpdate();
      return;
    }

    const tiposDocumento: Array<string> = this.documentoAdicionalFiles[
      index
    ].map(() => tipoDocumento);
    this.tiposDocumentoByDocumento.tipoDocumentoDocumentosAdicionales[index] =
      tiposDocumento;

    this.showDocumentoAdicionalFilesRequiredError[index] = false;

    const anyFileTypeInvalid: boolean = this.documentoAdicionalFiles[
      index
    ].some((x) => !this.fileConfig.allowedFileTypes.includes(x.type));

    const anyFileExtensionInvalid: boolean = this.documentoAdicionalFiles[
      index
    ].some((x) =>
      this.fileConfig.notAllowExtensions.some((substring) =>
        x.name.includes(substring)
      )
    );

    if (anyFileExtensionInvalid || anyFileTypeInvalid) {
      this.showInvalidDocumentoAdicionalFilesTypeError[index] = true;
    } else {
      this.showInvalidDocumentoAdicionalFilesTypeError[index] = false;
    }

    const anyFileSizeInvalid: boolean = this.documentoAdicionalFiles[
      index
    ].some((x) => x.size / 1000000 > this.fileConfig.fileSizeMbLimit);
    this.showInvalidDocumentoAdicionalFilesSizeError[index] =
      anyFileSizeInvalid;

    this.$forceUpdate();
  }

  public async getTiposDocumento() {
    this.tiposDocumentoLoading = true;
    const response = await this.vejezAnticipadaService.documentosRequeridos(
      String(this.formWizardSteps.secondStep.tabIndex + 1)
    );
    if (response.data.entities) {
      this.tiposDocumento = response.data.entities;
    } else {
      this.tiposDocumento = [];
    }
    this.tiposDocumentoLoading = false;
  }

  public async getViasNotificacion(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.viasNotificacionLoading = true;
    const response = await this.afiliadoService.viasNotificacion(term);
    if (response.data.entity) {
      this.viasNotificacion = response.data.entity;
    } else {
      this.viasNotificacion = [];
    }
    this.viasNotificacionLoading = false;
  }
  public async getAseguradoras(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.aseguradorasLoading = true;
    const response = await this.afiliadoService.aseguradoras(term);

    if (response.data.entities) {
      this.aseguradoras = response.data.entities;
    } else {
      this.aseguradoras = [];
    }
    this.aseguradorasLoading = false;
  }

  public async getBancos(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.bancosLoading = true;
    const response = await this.afiliadoService.bancos(term);
    if (response.data.entities) {
      this.bancos = response.data.entities;
    } else {
      this.bancos = [];
    }
    this.bancosLoading = false;
  }

  public async getMetodosDePago(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.metodosDePagoLoading = true;
    const response = await this.afiliadoService.metodosDePago(
      this.user.monSalarioRetiro,
      term
    );
    if (response.data.entities) {
      this.metodosDePago = response.data.entities.filter(
        (x) =>
          x.topeMinimo <= this.user.monSalarioRetiro &&
          x.topeMaximo >= this.user.monSalarioRetiro
      );
    } else {
      this.metodosDePago = [];
    }
    this.metodosDePagoLoading = false;
  }

  public async getTiposDeCuenta(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.tiposDeCuentaLoading = true;
    const response = await this.afiliadoService.tiposDeCuenta(term);
    if (response.data.entity) {
      this.tiposDeCuenta = response.data.entity;
    } else {
      this.tiposDeCuenta = [];
    }
    this.tiposDeCuentaLoading = false;
  }

  public firstStepIsValid(): boolean {
    if (!this.currentPresolicitudEsModificable) {
      return true;
    }
    if (this.previousCedulaFrontalRequiereCambioDoc) {
      if (!this.inputCedulaFrontalIsValid) {
        return false;
      }
    }
    if (this.previousCedulaTraseraRequiereCambioDoc) {
      if (!this.inputCedulaTraseraIsValid) {
        return false;
      }
    }
    return (
      (this.inputsCedulaAreValid && this.cedulaIsValid) ||
      this.existPreviousCedulaFiles
    );
  }

  public secondStepIsValid(): boolean {
    if (!this.currentPresolicitudEsModificable) {
      return true;
    }
    if (this.datosCedulaCoincideConBD) {
      return true;
    }
    if (this.existPreviousDocumentoFiles) {
      if (this.previousDocumentoRequiereCambioDoc) {
        if (!this.documentoIsValid) {
          return false;
        }
      } else {
        return true;
      }
    }

    if (this.omitirActualizacionDatos) {
      return true;
    }
    if (!this.datosCedulaCoincideConBD) {
      return true;
    }
    return this.documentoIsValid;
  }

  public fifthStepIsValid(): boolean {
    if (!this.currentPresolicitudEsModificable) {
      return true;
    }
    if (this.previousReferenciaDocumentoBancarioRequiereCambioDoc) {
      if (!this.existReferenciaDocumentoBancarioFiles) {
        return false;
      }
    }
    return !!this.numeroSolicitudCreada;
  }

  get metodoDePagoIsTransferenciaBancaria(): boolean {
    return this.metodoDePago && this.metodoDePago.formaPago === "T";
  }

  get existReferenciaDocumentoBancarioFiles(): boolean {
    return (
      this.referenciaDocumentoBancarioFiles &&
      this.referenciaDocumentoBancarioFiles.length > 0
    );
  }
  get existCartaAseguradoraFiles(): boolean {
    return this.cartaAseguradoraFiles && this.cartaAseguradoraFiles.length > 0;
  }

  get existPreviousCedulaFrontalFiles(): boolean {
    return !(
      this.previousCedulaFrontalFiles &&
      this.previousCedulaFrontalFiles.length === 0
    );
  }
  get existPreviousActaNacimientoFiles(): boolean {
    return !(
      this.previousActaNacimientoFiles &&
      this.previousActaNacimientoFiles.length === 0
    );
  }

  get existPreviousCedulaTraseraFiles(): boolean {
    return !(
      this.previousCedulaTraseraFiles &&
      this.previousCedulaTraseraFiles.length === 0
    );
  }

  get existPreviousCedulaFiles(): boolean {
    return (
      this.existPreviousCedulaFrontalFiles &&
      this.existPreviousCedulaTraseraFiles
    );
  }

  get existPreviousDocumentoFiles(): boolean {
    return !(
      this.previousDocumentoFiles && this.previousDocumentoFiles.length === 0
    );
  }

  get existPreviousReferenciaDocumentoBancarioFiles(): boolean {
    return !(
      this.previousReferenciaDocumentoBancarioFiles &&
      this.previousReferenciaDocumentoBancarioFiles.length === 0
    );
  }
  get existPreviousCartaAseguradoraFiles(): boolean {
    return !(
      this.previousCartaAseguradoraFiles &&
      this.previousCartaAseguradoraFiles.length === 0
    );
  }
  get existPreviousDocumentoAdicionalFiles(): boolean {
    return !(
      this.previousDocumentoAdicionalFiles &&
      this.previousDocumentoAdicionalFiles.length === 0
    );
  }

  get generaSolicitudAutomatica(): boolean {
    return (
      !this.metodoDePagoIsTransferenciaBancaria &&
      this.datosCedulaCoincideConBD &&
      !this.isRentaVitalicia
    );
  }

  get valorViaNotificacionActual(): string {
    if (this.viaNotificacion) {
      switch (this.viaNotificacion.value) {
        case "E":
          return this.user.correoElectronico1 || this.user.correoElectronico2;
        case "C":
          return this.user.celular;
        default:
          return;
      }
    } else {
      return null;
    }
  }

  public nextAction(
    success: boolean,
    nextAction: (props: any, _this: RegistroVejezAnticipada) => any,
    props: any
  ): void {
    if (success) {
      if (nextAction) {
        nextAction(props, this);
      }
    }
  }

  public async verificarCedulaYActaNacimiento(): Promise<boolean> {
    if (!this.existPreviousCedulaFiles && !this.inputsCedulaAreValid) {
      this.callInputValidation();
      return false;
    }

    //var resultActaNacimiento = await this.verificarActaNacimiento();
    var resultCedula = await this.verificarCedula();
    return resultCedula;
  }

  public async verificarActaNacimiento(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (
        !this.existPreviousActaNacimientoFiles &&
        !this.inputsActaNacimientoAreValid
      ) {
        this.callInputValidation();
        resolve(this.actaNacimientoIsValid);
        return;
      }

      if (
        this.previousActaNacimientoRequiereCambioDoc &&
        !this.inputActaNacimientoIsValid
      ) {
        this.callInputValidation();
        resolve(this.actaNacimientoIsValid);
        return;
      }

      if (
        !this.existPreviousActaNacimientoFiles ||
        this.previousActaNacimientoRequiereCambioDoc
      ) {
        this.actaNacimientoServerMessage = "";
        this.showLoadingAlert(
          "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital de beneficios."
        );
        this.loading = true;
        this.validationService
          .validateActaNacimiento(
            new ValidacionActaNacimiento(
              this.user.cedula,
              this.user.getNombreCompleto(),
              this.user.fechaNacimientoDate,
              this.previousActaNacimientoFiles &&
              this.previousActaNacimientoFiles.length > 0
                ? this.previousActaNacimientoFiles[0].ruta
                : null
            ),
            {
              acta: this.actaNacimientoFiles,
            }
          )
          .then(
            (
              response: AxiosResponse<
                ServiceResponseEntity<ValidacionActaNacimientoResp>
              >
            ) => {
              if (response.data.respCode == 200) {
                this.datosActaNacimientoCoincideConBD = true;
                this.resultValidacionActaNacimiento = response.data.entity;
                this.actaNacimientoIsValid = true;
              } else {
                switch (response.data.respCode) {
                  case 410:
                    // Nombre afiliado no coincide
                    this.datosActaNacimientoCoincideConBD = false;
                    this.resultValidacionActaNacimiento = response.data.entity;
                    if (this.resultValidacionActaNacimiento.nombreCoincide) {
                      this.actaNacimientoIsValid = true;
                    }
                    break;
                  case 411:
                    // Cedula frontal de baja calidad
                    this.datosActaNacimientoCoincideConBD = false;
                    this.actaNacimientoServerMessage = response.data.message;
                    break;
                  case 412:
                    // Cedula trasera de baja calidad
                    this.datosActaNacimientoCoincideConBD = false;
                    this.actaNacimientoServerMessage = response.data.message;
                    break;
                  case 413:
                    //No es un acta de nacimiento
                    this.datosActaNacimientoCoincideConBD = false;
                    this.actaNacimientoServerMessage = response.data.message;
                    this.inputActaNacimientoIsValid = false;
                    // this.loading = false;
                    // resolve(false);
                    // return;
                    break;
                  default:
                    this.loading = false;
                    this.showErrorAlert(
                      "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
                      true
                    );
                    resolve(false);
                    return;
                }

                //Each time cedula validation run, update currentPresolicitud values
                if (this.currentPresolicitud) {
                  this.currentPresolicitud.nombreActaNacimientoCoincide =
                    this.resultValidacionActaNacimiento.nombreCoincide;
                  this.currentPresolicitud.fechaNacimientoActaNacimientoCoincide =
                    this.resultValidacionActaNacimiento.fechaNacimientoCoincide;
                }
              }
              this.loading = false;
              Swal.close();
              resolve(this.inputActaNacimientoIsValid);
              //cuando el acta no corresponda a la persona en nada
              // if (!this.resultValidacionCedula.cedulaCoincide) {
              //     Swal.fire({
              //         text: "El número de cédula de identidad del documento que cargó no coincide con el número de cédula registrado en nuestra base de datos. Ambos números deben coincidir para que puedas continuar con el registro de su solicitud.",
              //         icon: "warning",
              //         confirmButtonText: "OK",
              //     });
              // }
            }
          )
          .catch(() => {
            this.loading = false;
            Swal.close();
            reject();
          });
      } else {
        this.loading = false;
        Swal.close();
        resolve(true);
      }
    });
  }

  public async verificarCedula(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (!this.existPreviousCedulaFiles && !this.inputsCedulaAreValid) {
        this.callInputValidation();
        resolve(this.cedulaIsValid);
        return;
      }
      if (
        (this.previousCedulaFrontalRequiereCambioDoc &&
          !this.inputCedulaFrontalIsValid) ||
        (this.previousCedulaTraseraRequiereCambioDoc &&
          !this.inputCedulaTraseraIsValid)
      ) {
        this.callInputValidation();
        resolve(this.cedulaIsValid);
        return;
      }
      if (
        !this.existPreviousCedulaFiles ||
        this.previousCedulaFrontalRequiereCambioDoc ||
        this.previousCedulaTraseraRequiereCambioDoc
      ) {
        this.cedulaFrontalServerMessage = "";
        this.cedulaTraseraServerMessage = "";
        this.showLoadingAlert(
          "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital de beneficios."
        );
        this.loading = true;
        this.validationService
          .validateCedulaAfiliadoIT(
            new ValidacionCedulaIt(
              this.user.cedula,
              this.user.getNombreCompleto(),
              this.user.fechaNacimientoDate,
              this.previousCedulaFrontalFiles &&
              this.previousCedulaFrontalFiles.length > 0
                ? this.previousCedulaFrontalFiles[0].ruta
                : null,
              this.previousCedulaTraseraFiles &&
              this.previousCedulaTraseraFiles.length > 0
                ? this.previousCedulaTraseraFiles[0].ruta
                : null
            ),
            {
              cedulaFrontal: this.cedulaFrontalFiles,
              cedulaTrasera: this.cedulaTraseraFiles,
            }
          )
          .then(
            (
              response: AxiosResponse<
                ServiceResponseEntity<ValidacionCedulaItResp>
              >
            ) => {
              if (response.data.respCode == 200) {
                this.datosCedulaCoincideConBD = true;
                this.resultValidacionCedula = response.data.entity;
                this.cedulaIsValid = true;
              } else {
                switch (response.data.respCode) {
                  case 410:
                    // Nombre afiliado no coincide
                    this.datosCedulaCoincideConBD = false;
                    this.resultValidacionCedula = response.data.entity;
                    if (this.resultValidacionCedula.cedulaCoincide) {
                      this.cedulaIsValid = true;
                    }
                    break;
                  case 411:
                    // Cedula frontal de baja calidad
                    this.cedulaFrontalServerMessage = response.data.message;
                    break;
                  case 412:
                    // Cedula trasera de baja calidad
                    this.cedulaTraseraServerMessage = response.data.message;
                    break;
                  default:
                    this.loading = false;
                    this.showErrorAlert(
                      "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
                      true
                    );
                    resolve(false);
                    return;
                }

                //Each time cedula validation run, update currentPresolicitud values
                if (this.currentPresolicitud) {
                  this.currentPresolicitud.cedulaCoincide =
                    this.resultValidacionCedula.cedulaCoincide;
                  this.currentPresolicitud.nombreCoincide =
                    this.resultValidacionCedula.nombreCoincide;
                  this.currentPresolicitud.fechaNacimientoCoincide =
                    this.resultValidacionCedula.fechaNacimientoCoincide;
                }
              }
              this.loading = false;
              Swal.close();
              resolve(this.cedulaIsValid);
              if (!this.resultValidacionCedula.cedulaCoincide) {
                Swal.fire({
                  text: "El número de cédula de identidad del documento que cargó no coincide con el número de cédula registrado en nuestra base de datos. Ambos números deben coincidir para que puedas continuar con el registro de su solicitud.",
                  icon: "warning",
                  confirmButtonText: "OK",
                });
              }
            }
          )
          .catch(() => {
            this.loading = false;
            Swal.close();
            reject();
          });
      } else {
        this.loading = false;
        Swal.close();
        resolve(true);
      }
    });
  }

  public async invalidarSolicitud(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.showLoadingConfirm(
        "Lo sentimos, actualmente no cumples con los requisitos para continuar con esta solicitud de beneficios. Esta será anulada.",
        () => {
          const registroPresolicitud = new RegistroPresolicitud();
          registroPresolicitud.presolicitud.tipoBeneficio =
            TipoBeneficioEnum.VejezAnticipada.toString();
          registroPresolicitud.presolicitud.numeroSolicitud =
            this.numeroSolicitud;
          registroPresolicitud.presolicitud.cedulaAfiliado = this.user.cedula;
          registroPresolicitud.presolicitud.cedulaBeneficiario =
            this.user.cedula;
          registroPresolicitud.presolicitud.estado = "C";
          this.afiliadoService
            .registroPresolicitud(registroPresolicitud, {
              cedula: null,
              docsActDatos: null,
              referenciaDocumentoBancario: null,
              documentosAdicionales: null,
            })
            .then((response: AxiosResponse<ServiceResponseSolicitud>) => {
              if (response.data.respCode === 200) {
                Swal.close();
                this.$router.push("/home");
                resolve();
              } else {
                this.showErrorAlert(
                  response.data.message ||
                    "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
                  false
                );
                resolve();
              }
            })
            .catch((error) => {
              this.showErrorAlert(
                "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
                false
              );
              reject();
            });
        }
      );
    });
  }

  public async completarPresolicitud(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (
        !this.isEditing ||
        (this.isEditing &&
          (this.currentPresolicitudEsModificable ||
            this.previousCedulaFrontalRequiereCambioDoc ||
            this.previousCedulaTraseraRequiereCambioDoc ||
            this.previousDocumentoRequiereCambioDoc ||
            this.previousCartaAseguradoraRequiereCambioDoc ||
            this.documentosAdicionales.length > 0 ||
            this.previousReferenciaDocumentoBancarioRequiereCambioDoc ||
            this.nuevaCartaAseguradoraAgregada))
      ) {
        if (!this.generaSolicitudAutomatica) {
          this.registrarPresolicitud()
            .then((response: boolean) => {
              this.loading = false;
              setTimeout(() => Swal.close(), 4000);
              resolve(response);
            })
            .catch(() => {
              reject();
            });
        } else {
          resolve(true);
        }
      } else {
        resolve(true);
      }
    });
  }

  public async registrarPresolicitud(
    showLoading: boolean = true,
    packageId?: string
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      (this.$refs.registroIngresoTardioForm as VeeValidateForm)
        .validate()
        .then(async (isValid: boolean) => {
          console.log("Validation Form Execured, result: " + isValid);
          //
          if (isValid) {
            this.clearUnusedFields();
            //
            if (
              this.metodoDePagoIsTransferenciaBancaria &&
              !this.existReferenciaDocumentoBancarioFiles &&
              !this.existPreviousReferenciaDocumentoBancarioFiles
            ) {
              console.log(
                "Metodo pago es transferencia y no referencia Doc Bancario, ni en input ni en previous"
              );
              this.showReferenciaDocumentoBancarioFilesRequiredError = true;
              resolve(!!this.numeroSolicitudCreada);
              return;
            }
            if (
              this.metodoDePagoIsTransferenciaBancaria &&
              this.previousReferenciaDocumentoBancarioRequiereCambioDoc &&
              !this.existReferenciaDocumentoBancarioFiles
            ) {
              this.showReferenciaDocumentoBancarioFilesRequiredError = true;
              resolve(!!this.numeroSolicitudCreada);
              return;
            }
            if (showLoading) {
              this.showLoadingAlert("Se están registrando los datos");
              this.loading = true;
            }
            this.showReferenciaDocumentoBancarioServerValidationMessage = false;
            this.registroPresolicitud.presolicitud.tipoBeneficio =
              TipoBeneficioEnum.VejezAnticipada.toString();
            //this.registroPresolicitud.presolicitud.tipoBeneficio = "1";
            this.registroPresolicitud.presolicitud.numeroSolicitud =
              this.numeroSolicitud;
            //
            this.registroPresolicitud.presolicitud.cedulaCoincide =
              this.resultValidacionCedula.cedulaCoincide;
            this.registroPresolicitud.presolicitud.nombreCoincide =
              this.resultValidacionCedula.nombreCoincide;
            this.registroPresolicitud.presolicitud.fechaNacimientoCoincide =
              this.resultValidacionCedula.fechaNacimientoCoincide;
            this.registroPresolicitud.presolicitud.formaPago =
              this.metodoDePago?.formaPago;
            //seteando valores del acta en la presolicitud
            // this.registroPresolicitud.presolicitud.nombreActaNacimientoCoincide = this.resultValidacionActaNacimiento.nombreCoincide;
            // this.registroPresolicitud.presolicitud.fechaNacimientoActaNacimientoCoincide = this.resultValidacionActaNacimiento.fechaNacimientoCoincide;
            this.registroPresolicitud.presolicitud.codigoAseguradora =
              this.aseguradora?.codigoAseguradora;
            //tipoPension
            this.registroPresolicitud.presolicitud.tipoPension =
              this.TipoPension.value;
            //if(this.TipoPension != null && this.TipoPension.codigo =="3" && (!this.cartaAseguradoraFiles || !this.previousActaNacimientoFile) )
            if (this.metodoDePagoIsTransferenciaBancaria) {
              if (this.banco) {
                this.registroPresolicitud.presolicitud.idBanco = Number(
                  this.banco.codigoBanco
                );
              }
              if (this.tipoDeCuenta) {
                this.registroPresolicitud.presolicitud.tipoCuenta =
                  this.tipoDeCuenta.value;
              }
              this.registroPresolicitud.presolicitud.numeroCuenta =
                this.numeroCuenta;
            }
            this.registroPresolicitud.presolicitud.cedulaAfiliado =
              this.user.cedula;
            this.registroPresolicitud.presolicitud.cedulaBeneficiario =
              this.user.cedula;
            this.registroPresolicitud.presolicitud.codCuenta =
              this.user.codCuenta;
            if (packageId) {
              this.registroPresolicitud.presolicitud.idTransFirma = packageId;
            }
            this.registroPresolicitud.presolicitud.formaGeneraSolicitud = this
              .generaSolicitudAutomatica
              ? FormaGeneraSolicitudEnum.Automatica
              : FormaGeneraSolicitudEnum.Manual;
            if (this.viaNotificacion) {
              this.registroPresolicitud.presolicitud.viaNotificacion =
                this.viaNotificacion.value;
              var valorViaNotificacion =
                this.valorViaNotificacion || this.valorViaNotificacionActual;
              //
              if (this.viaNotificacion) {
                switch (this.viaNotificacion.value) {
                  case "E":
                    this.registroPresolicitud.presolicitud.eMail =
                      valorViaNotificacion;
                    this.user.correoElectronico1 = valorViaNotificacion;
                    break;
                  case "C":
                    this.registroPresolicitud.presolicitud.numTelefono =
                      valorViaNotificacion;
                    this.user.celular = valorViaNotificacion;
                    break;
                  default:
                    break;
                }
              }
            }
            this.registroPresolicitud.presolicitud = this.setDatosTss(
              this.registroPresolicitud.presolicitud
            );

            if (this.currentPresolicitud) {
              //Si existe el currentPresolicitud, utilizar el mismo idTransfirma para no sobreescribir
              this.registroPresolicitud.presolicitud.idTransFirma =
                this.currentPresolicitud.idTransFirma;
            }
            //Esto es para mover los archivos que requieren cambios a removedFiles
            this.removeFilesThatRequireChanges();
            //
            this.registroPresolicitud.archivosEliminados = this.removedFiles;
            this.registroPresolicitud.tiposDocumento = [];

            //#region Tipos de documento
            // 1) Cédulas
            this.cedulaFiles.forEach(() => {
              this.registroPresolicitud.tiposDocumento.push(
                this.tiposDocumentoByDocumento.tipoDocumentoCedula
              );
            });

            // 2) Acta de nacimiento
            this.getActaNacimientoFiles.forEach(() => {
              this.registroPresolicitud.tiposDocumento.push(
                this.tiposDocumentoByDocumento.tipoDocumentoActaNacimiento
              );
            });

            // 3) Carta aseguradora
            this.getCartaAseguradoraFiles.forEach(() => {
              this.registroPresolicitud.tiposDocumento.push(
                this.tiposDocumentoByDocumento.tipoDocumentoCartaAseguradora
              );
            });

            // 4) Documento principal (actualización de datos)
            if (this.documentoFiles.length && this.tipoDocumento) {
              this.documentoFiles.forEach(() => {
                this.registroPresolicitud.tiposDocumento.push(
                  this.tipoDocumento.codRequisito.toString()
                );
              });
            }

            // 5) Referencia documento bancario
            this.referenciaDocumentoBancarioFiles.forEach(() => {
              this.registroPresolicitud.tiposDocumento.push(
                this.tiposDocumentoByDocumento
                  .tipoDocumentoReferenciaDocumentoBancario
              );
            });

            // 6) Documentos adicionales POR ÍNDICE (sin flat aquí)
            this.documentoAdicionalFiles.forEach(
              (documentoAdicionalFile: Array<File>, index: number) => {
                const tiposDocumentoDelIndex =
                  this.tiposDocumentoByDocumento
                    .tipoDocumentoDocumentosAdicionales[index] || [];

                // LOG diagnóstico si algo no cuadra
                if (
                  tiposDocumentoDelIndex.length !==
                  documentoAdicionalFile.length
                ) {
                  console.warn(
                    "[ADICIONALES VEJEZ] Descuadre en index",
                    index,
                    "files=",
                    documentoAdicionalFile.length,
                    "tipos=",
                    tiposDocumentoDelIndex.length
                  );
                }

                tiposDocumentoDelIndex.forEach((tipo) => {
                  this.registroPresolicitud.tiposDocumento.push(tipo);
                });
              }
            );

            // 7) Check global de consistencia (muy recomendado)
            const totalFiles =
              this.cedulaFiles.length +
              this.getActaNacimientoFiles.length +
              this.getCartaAseguradoraFiles.length +
              this.documentoFiles.length +
              this.referenciaDocumentoBancarioFiles.length +
              this.documentoAdicionalFiles.flat().length;

            if (
              totalFiles !== this.registroPresolicitud.tiposDocumento.length
            ) {
              console.error("DESCUADRE archivos vs tiposDocumento EN VEJEZ", {
                totalFiles,
                tiposDocumentoCount:
                  this.registroPresolicitud.tiposDocumento.length,
                tipos: this.registroPresolicitud.tiposDocumento,
              });
            }
            //#endregion

            this.afiliadoService
              .registroPresolicitud(this.registroPresolicitud, {
                cedula: this.cedulaFiles,
                actaNacimiento: this.getActaNacimientoFiles,
                cartaAseguradora: this.getCartaAseguradoraFiles,
                docsActDatos: this.documentoFiles,
                referenciaDocumentoBancario:
                  this.referenciaDocumentoBancarioFiles,
                documentosAdicionales: this.documentoAdicionalFiles.flat(),
              })
              .then((response: AxiosResponse<ServiceResponseSolicitud>) => {
                if (response.data.respCode === 200) {
                  window.removeEventListener(
                    "beforeunload",
                    this.beforeUnloadHandler
                  );
                  this.numeroSolicitudCreada = response.data.numeroSolicitud;
                  this.numeroSolicitud = this.numeroSolicitudCreada;
                  this.setUserLoggedAction(this.user);
                } else if (response.data.respCode === 403) {
                  this.showErrorAlert(response.data.message, false);
                } else {
                  this.showErrorAlert(
                    "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde."
                  );
                }

                resolve(!!this.numeroSolicitudCreada);
              })
              .catch(() => {
                this.loading = false;
                Swal.close();
                this.showErrorAlert(
                  "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde."
                );
                reject();
              });
          } else {
            this.loading = false;
            Swal.close();
            resolve(!!this.numeroSolicitudCreada);
          }
        })
        .catch((x) => {
          this.loading = false;
          Swal.close();
          reject();
        });
    });
  }

  public async navigateToSolicitudes(): Promise<boolean> {
    window.removeEventListener("beforeunload", this.beforeUnloadHandler);
    return new Promise((resolve, reject) => {
      this.$router.push("/solicitudes-beneficiario");
      resolve(true);
    });
  }

  public async returnTrue() {
    return true;
  }

  public async getTiposPension() {
    const response = await this.afiliadoService.tiposPension();
    if (response.data.entity) {
      this.TiposPension = response.data.entity;
    } else {
      this.TiposPension = [];
    }
    // await this.vejezAnticipadaService
    //         .tipoPension(
    //         )
    //         .then(
    //             (
    //                 response: AxiosResponse<
    //                     ServiceResponseEntities<TipoPension[]>
    //                 >
    //             ) => {
    //
    //                 this.TiposPension = response.data.entities.filter( tipo => tipo.activo === true);
    //             }
    //         );
  }
  public async firmarContratoVejezAnticipada(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.registrarPresolicitud()
        .then((result: boolean) => {
          if (result) {
            const firmante: FirmanteContratoIngresoTardio =
              new FirmanteContratoIngresoTardio(
                this.user.correoElectronico1 || this.user.correoElectronico2,
                this.user.getNombres(),
                this.user.getApellidos(),
                this.user.celular,
                this.user.cedula,
                null,
                null,
                this.user.codCiudad,
                this.numeroSolicitudCreada,
                null,
                this.user.saldoCCI,
                this.user.fechaNacimientoDate,
                this.user.telefonoResidencia,
                this.user.userIdentityEncrypt,
                this.user.TokenGenerate
              );
            this.afiliadoService
              .firmarContratoVejezAnticipada(firmante)
              .then((response: AxiosResponse<PackageResult>) => {
                this.signUrlContrato = response.data.signingUrl;
                // this.loading = false;
                //  Swal.close();
                //
                resolve(true);
              })
              .catch(() => {
                this.loading = false;
                Swal.close();
                this.showErrorAlert(
                  "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde."
                );
                reject();
              });
          } else {
            this.loading = false;
            setTimeout(() => Swal.close(), 4000);
            //Swal.close();
            resolve(false);
          }
        })
        .catch(() => {
          this.loading = false;
          setTimeout(() => Swal.close(), 4000);
          //Swal.close();
          this.showErrorAlert(
            "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde."
          );
          reject();
        });
    });
  }

  //     @Watch('TipoPension')
  //      onPropertyChanged(value: TipoPension, oldValue: TipoPension) {
  //     if(value !== null){
  //         // this.enableStep(
  //         //     this.formWizardSteps.fifthStep.formWizardChildrenIndex)

  //          };

  //   }
}
